// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file tsam/v1/monitoring.proto (package tsam.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tsam/v1/monitoring.proto.
 */
export const file_tsam_v1_monitoring: GenFile = /*@__PURE__*/
  fileDesc("Chh0c2FtL3YxL21vbml0b3JpbmcucHJvdG8SB3RzYW0udjEiDwoNSGVhbHRoUmVxdWVzdCJlCg5IZWFsdGhSZXNwb25zZRIPCgd2ZXJzaW9uGAEgASgJEg4KBmJyYW5jaBgCIAEoCRILCgNzaGEYAyABKAkSEwoLY29tcGlsZWRfYXQYBCABKAkSEAoIY29tcGlsZXIYBSABKAkyUAoRTW9uaXRvcmluZ1NlcnZpY2USOwoGSGVhbHRoEhYudHNhbS52MS5IZWFsdGhSZXF1ZXN0GhcudHNhbS52MS5IZWFsdGhSZXNwb25zZSIAYgZwcm90bzM");

/**
 * @generated from message tsam.v1.HealthRequest
 */
export type HealthRequest = Message<"tsam.v1.HealthRequest"> & {
};

/**
 * Describes the message tsam.v1.HealthRequest.
 * Use `create(HealthRequestSchema)` to create a new message.
 */
export const HealthRequestSchema: GenMessage<HealthRequest> = /*@__PURE__*/
  messageDesc(file_tsam_v1_monitoring, 0);

/**
 * @generated from message tsam.v1.HealthResponse
 */
export type HealthResponse = Message<"tsam.v1.HealthResponse"> & {
  /**
   * version is the semantic version of the binary that is running
   *
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string sha = 3;
   */
  sha: string;

  /**
   * @generated from field: string compiled_at = 4;
   */
  compiledAt: string;

  /**
   * @generated from field: string compiler = 5;
   */
  compiler: string;
};

/**
 * Describes the message tsam.v1.HealthResponse.
 * Use `create(HealthResponseSchema)` to create a new message.
 */
export const HealthResponseSchema: GenMessage<HealthResponse> = /*@__PURE__*/
  messageDesc(file_tsam_v1_monitoring, 1);

/**
 * The Monitoring service provides methods to monitor application.
 *
 * @generated from service tsam.v1.MonitoringService
 */
export const MonitoringService: GenService<{
  /**
   * Health allow you to know if the api is up.
   *
   * @generated from rpc tsam.v1.MonitoringService.Health
   */
  health: {
    methodKind: "unary";
    input: typeof HealthRequestSchema;
    output: typeof HealthResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tsam_v1_monitoring, 0);

